/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BodyEventsFeaturesEnum {
    COLOR = 'color',
}